const managementTabPath = 'educationHub.managementTabLabels.';

const managementTrans = {
    COUNSELLING_PATIENTS_LABEL: managementTabPath + 'counsellingPatients',
    COLLABORATING_COLLEAGUES_LABEL: managementTabPath + 'collaboratingColleagues',
    CODING_FOR_GA_LABEL: managementTabPath + 'codingForGA'
}

export default managementTrans